const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const Link = require("./Link");
const styles = require("./styles/OctagonalButton.css");

module.exports = createReactClass({
	displayName: "OctagonalButton",

	propTypes: {
		handleClick: PT.func,
		className: PT.string,
		buttonText: PT.string,
		linkTo: PT.string,
		isNewTab: PT.bool,
	},

	onClick: function() {
		this.props.handleClick && this.props.handleClick();
	},

	getButton: function(buttonText, linkTo) {
		let octagonBody = (
			<div className={styles.octagonWrapper}>
				<svg
					version="1.1"
					xmlns="http://www.w3.org/2000/svg"
					viewBox="0 0 73.29 75.74"
					preserveAspectRatio="none"
					className={styles.octagonSvg}
					width={73.29}
					height={75.74}
				>
					<polygon
						className={styles.shadow}
						points="
							42.57 2
							10.41 12.54
							2 34.3
							8.36 60.69
							30.86 75.74
							61.38 67.75
							73.29 44.64
							69.7 12.77
							40.57 2"
					/>
					<polygon
						className={styles.border}
						points="38.57 0 8.41 10.54 0 32.3 6.36 58.69 28.86 73.74 59.38 65.75 71.29 42.64 67.7 10.77 38.57 0"
					/>
					<polygon
						className={styles.bg}
						points="39.38 2.75 12.03 12.48 3.22 34.73 10.18 56.98 30.57 70.88 57.45 62.54 69.04 42.15 63.94 13.41 39.38 2.75"
					/>
				</svg>
			</div>
		);
		if (this.props.linkTo) {
			octagonBody = (
				<Link to={linkTo} useWonkyCursor={true} isNewTab={this.props.isNewTab}>
					{octagonBody}
				</Link>
			);
		}
		return (
			<div className={styles.buttonWrapper}>
				<div
					className={styles.button}
					onClick={this.onClick}
					onKeyPress={this.onKeyPress}
				>
					{octagonBody}
					<div className={styles.buttonContent}>
						<div className={styles.text}>{buttonText}</div>
					</div>
				</div>
			</div>
		);
	},

	render: function() {
		const buttonText = this.props.buttonText;
		const buttonImage = this.getButton(buttonText, this.props.linkTo);
		return (
			<div className={styles.main + " " + this.props.className}>
				{buttonImage}
			</div>
		);
	},
});
